export enum AppRoutes {
    LOGIN = 'login',
    TRANSFORM = 'transform'
} 